import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer footer-center bg-slate-950 text-slate-400 p-12 border-t border-white/5 flex flex-col items-center">
      {/* 1. ÍCONES SOCIAIS (AGORA NO TOPO) */}
      <nav className="mb-8">
        <div className="grid grid-flow-col gap-6">
          <a
            href="https://instagram.com/lilybookclub"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-white/5 hover:bg-wine/10 hover:text-wine transition-all duration-300 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=lilybookclubb@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-white/5 hover:bg-wine/10 hover:text-wine transition-all duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
          </a>
        </div>
      </nav>

      {/* 2. LINKS DE NAVEGAÇÃO */}
      <nav className="grid grid-flow-col gap-8 mb-8">
        <button
          onClick={() => navigate('/sobre')}
          className="text-[10px] font-black uppercase tracking-[0.3em] hover:text-wine transition-all duration-300 cursor-pointer border-none bg-transparent"
        >
          Sobre nós
        </button>
        <button
          onClick={() => navigate('/faq')}
          className="text-[10px] font-black uppercase tracking-[0.3em] hover:text-wine transition-all duration-300 cursor-pointer border-none bg-transparent"
        >
          FAQ
        </button>
        <a
          href="https://wa.me/559292533120"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[10px] font-black uppercase tracking-[0.3em] hover:text-wine transition-all duration-300 cursor-pointer no-underline"
        >
          Contato
        </a>
      </nav>

      {/* DIVISOR SUTIL */}
      <div className="w-12 h-[1px] bg-white/10 mb-6"></div>

      {/* 3. COPYRIGHT MINIMALISTA */}
      <aside className="opacity-40 text-center">
        <p className="text-[9px] font-bold uppercase tracking-[0.4em] text-white">
          Lily Book Club <span className="text-wine">©</span>{' '}
          {new Date().getFullYear()}
        </p>
      </aside>
    </footer>
  );
};

export default Footer;
